// App.js - CORRECTED VERSION
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Web3Provider } from './context/Web3Context';
import Layout from './components/Layout';
import Home from './pages/Home';
import Dashboard from './pages/Dashboard';
import Stats from './pages/Stats';
import About from './pages/About';
import './App.css';

export default function App() {
  return (
    <Web3Provider>
      <Router>
        <Routes>
          {/* Wrap Layout around EACH route that needs it */}
          <Route path="/" element={<Layout />}>
            <Route index element={<Home />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="stats" element={<Stats />} />
            <Route path="about" element={<About />} />
          </Route>
        </Routes>
      </Router>
    </Web3Provider>
  );
}